import updateReduxAction from 'modules/redux/actions/update'
import getPathReduxUtil from 'modules/redux/utils/get-path'

function updateExerciseAction (params) {
  return (dispatch) => {
    const { key, value, instance } = params
    dispatch(
      updateReduxAction({
        type: 'EXERCISES_UPDATE',
        payload: {
          path: getPathReduxUtil(instance),
          key,
          value
        }
      })
    )
  }
}

export default updateExerciseAction
